<template>
  <div class="hover-button" :class="clazz"
    :style="{'transition-duration': duration+'s','-moz-transition-duration': duration+'s',
    '-webkit-transition-duration': duration+'s','-o-transition-duration':duration+'s'}">
    <div class="circle-outside"
         :style="{'transition-duration': duration+'s','-moz-transition-duration': duration+'s',
    '-webkit-transition-duration': duration+'s','-o-transition-duration':duration+'s'}">
      <div class="circle-inside"
           :style="{'transition-duration': duration+'s','-moz-transition-duration': duration+'s',
    '-webkit-transition-duration': duration+'s','-o-transition-duration':duration+'s'}"></div>
    </div>
    <span class="button-text"
          :style="{'transition-duration': duration+'s','-moz-transition-duration': duration+'s',
    '-webkit-transition-duration': duration+'s','-o-transition-duration':duration+'s'}">{{this.text}}</span>
  </div>
</template>
<script>
export default {
  name: 'hoverButton',
  props: {
    clazz: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '悬浮按钮'
    },
    duration: {
      type: Number,
      default: 0.5
    }
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss">
  .hover-button {
    cursor: pointer;
    position: relative;
    width:137px;
    height:28px;
    border-radius: 14px;
    background-color: #4CBACE;
    color: #fff;
    transition:background-color 1s;
    -moz-transition:background-color 1s; /* Firefox 4 */
    -webkit-transition:background-color 1s; /* Safari and Chrome */
    -o-transition:background-color 1s; /* Opera */
    .circle-outside {
      z-index: 10;
      display: inline-block;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      text-align: center;
      background-color: white;
      line-height: 28px;
      position: absolute;
      top: 3px;
      left: 3px;
      transition:left 1s;
      -moz-transition:left 1s; /* Firefox 4 */
      -webkit-transition:left 1s; /* Safari and Chrome */
      -o-transition:left 1s; /* Opera */
      .circle-inside {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #4CBACE;
        position: relative;
        bottom: 3.55px;
        transition:background-color 1s;
        -moz-transition:background-color 1s; /* Firefox 4 */
        -webkit-transition:background-color 1s; /* Safari and Chrome */
        -o-transition:background-color 1s; /* Opera */
      }
    }
    .button-text {
      z-index: 9;
      position: absolute;
      left: 30%;
      top: 7px;
      font-size: 14px;
      line-height: 1;
      font-weight: 400;
      transition:left 1s;
      -moz-transition:left 1s; /* Firefox 4 */
      -webkit-transition:left 1s; /* Safari and Chrome */
      -o-transition:left 1s; /* Opera */
    }
  }
  .hover-button:hover {
    background-color: #f5c137;
    .circle-outside {
      left: calc(100% - 25px);
      .circle-inside {
        background-color: #f5c137;
      }
    }
    .button-text {
      left: 16%;
    }
  }
</style>



// WEBPACK FOOTER //
// hoverButton.vue?294d7784